
import Expander from '@/components/elements/Expander';

export default {
  name: 'Brands',
  components: {
    Expander,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      maxCount: 5,
    }
  },
};
